import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlSendLoad extends Layout {
    panelFirstRow: Panel;
    panelSecondRow: Panel;
    sourceMCControl: DataSource;
    switchSendFuelStops: Switch;
    switchSendLoadEmptyMiles: Switch;
    switchSendOvdLoadPay: Switch;
    switchSendRoute: Switch;
    textboxDirectionsForm: Textbox;
    textboxDispatchForm: Textbox;
    textboxEmptyForm: Textbox;
    textboxNameOfFreeform: Textbox;
    textboxRouteDistanceProfile: Textbox;
    textboxRouteForm: Textbox;
    textboxSendLoadDirections: Textbox;
    textboxSendLoadMiles: Textbox;
    textboxStopsForm: Textbox;
    textboxWireForm: Textbox;
}
